(function (scope, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!scope.customElements || scope.customElements.get('tp-physical-options')) return;
  scope.customElements.define('tp-physical-options', api.elementClass(scope));
})(typeof window === 'undefined' ? globalThis : window, function () {
  const sizeOrder = ['21x30', '30x40', '40x50', '50x70', '70x100'];
  const frameOrder = ['white', 'black', 'birch', 'oak', 'walnut'];
  const frames = { 'Cornice bianca': 'white', 'Cornice nera': 'black', 'Cornice betulla': 'birch', 'Cornice rovere': 'oak', 'Cornice noce': 'walnut' };
  function key(state) { return [state.size, state.style, state.frame || 'none', state.finish].join('|'); }
  function mapVariant(variant, kind) {
    if (variant.id === null || variant.id === undefined) return null;
    const raw = variant.options || [variant.option1, variant.option2, variant.option3];
    if (!Array.isArray(raw) || raw.length !== 3) return null;
    const size = String(raw[0]).split('cm/')[0].trim();
    if (!sizeOrder.includes(size) || (kind === 'copri' && size === '70x100')) return null;
    let style, frame = null;
    if (raw[1] === 'Tela') style = 'canvas';
    else if (kind === 'print' && raw[1] === 'Stampa senza cornice') style = 'print';
    else if (frames[raw[1]]) { style = 'framed'; frame = frames[raw[1]]; }
    else return null;
    let finish;
    if (raw[2] === 'Immagine intera') finish = 'full';
    else if ((style === 'print' && raw[2] === 'Bordo bianco') || (style === 'framed' && raw[2] === 'Con passepartout')) finish = 'poster';
    else return null;
    if (style === 'canvas' && finish !== 'full') return null;
    return { id: String(variant.id), size, style, frame, finish, rawOptions: raw.slice(), price: variant.price, available: variant.available !== false, source: variant };
  }
  function createModel(variants, kind) {
    if (!['print', 'copri'].includes(kind) || !Array.isArray(variants) || variants.length !== (kind === 'print' ? 65 : 44)) throw new Error('Unsupported physical option schema');
    const mapped = variants.map((variant) => mapVariant(variant, kind));
    if (mapped.some((variant) => !variant) || new Set(mapped.map(key)).size !== variants.length || new Set(mapped.map((variant) => variant.id)).size !== variants.length) throw new Error('Incomplete physical option mapping');
    return { kind, variants: mapped, sizes: sizeOrder.filter((size) => mapped.some((variant) => variant.size === size)), styles: ['canvas', 'print', 'framed'].filter((style) => mapped.some((variant) => variant.style === style)), frames: frameOrder.filter((frame) => mapped.some((variant) => variant.frame === frame)) };
  }
  function resolve(model, state) { return model.variants.find((variant) => key(variant) === key(state)) || null; }
  function stateFrom(variant) { return { size: variant.size, style: variant.style, frame: variant.frame, finish: variant.finish }; }
  function nextState(model, state, field, value) {
    const next = { ...state, [field]: value };
    if (next.style !== 'framed') next.frame = null;
    else if (!model.frames.includes(next.frame)) next.frame = model.frames[0];
    if (next.style === 'canvas') next.finish = 'full';
    if (field === 'style') {
      const current = resolve(model, next);
      if (!current?.available) {
        const alternatives = model.variants.filter((variant) => variant.size === next.size && variant.style === next.style && variant.available);
        const alternative = alternatives.find((variant) => variant.finish === next.finish) || alternatives[0];
        if (alternative) return stateFrom(alternative);
      }
    }
    return next;
  }
  function elementClass(win) {
    return class PhysicalOptions extends win.HTMLElement {
      connectedCallback() {
        if (this.initialized) { try { this.bindEvents(); } catch (_) { this.restoreNative(); } return; }
        this.initialized = true;
        try {
          this.wrapper = this.closest('[data-tp-physical-wrapper]');
          this.productInfo = this.closest('product-info');
          this.nativeWrapper = this.wrapper.querySelector('[data-tp-native-options]');
          const labels = JSON.parse(this.querySelector('[data-tp-physical-strings]').textContent);
          this.strings = Object.fromEntries(Object.entries(labels).map(([name, value]) => {
            const decoder = win.document.createElement('textarea'); decoder.innerHTML = value;
            return [name, decoder.value];
          }));
          this.model = createModel(JSON.parse(this.querySelector('[data-tp-physical-variants]').textContent), this.dataset.kind);
          this.ui = this.querySelector('[data-tp-physical-ui]');
          this.buildUi();
          this.changeHandler = (event) => {
            const input = event.target.closest('input[data-tp-field]');
            if (!input || !this.controls.includes(input)) return;
            const desired = nextState(this.model, this.state, input.dataset.tpField, input.value);
            const variant = resolve(this.model, desired);
            if (!variant || !variant.available) { this.renderState(); return; }
            this.state = desired;
            this.renderState();
            this.selectNative(variant);
          };
          this.observer = new win.MutationObserver(() => {
            const native = this.nativeWrapper.querySelector('variant-selects');
            if (native && native !== this.nativeElement) {
              if (!this.readNative()) this.restoreNative();
            }
          });
          this.bindEvents();
        } catch (_) { this.restoreNative(); }
      }
      bindEvents() {
        if (this.bound) return;
        this.productInfo = this.closest('product-info');
        if (!this.productInfo || !this.readNative()) throw new Error('Selected physical variant missing');
        this.productInfo.addEventListener('change', this.changeHandler);
        this.observer.observe(this.productInfo, { childList: true, subtree: true });
        this.nativeWrapper.hidden = true;
        this.hidden = false;
        this.wrapper.dataset.tpPhysicalReady = 'true';
        this.bound = true;
      }
      disconnectedCallback() { this.observer?.disconnect(); this.productInfo?.removeEventListener('change', this.changeHandler); if (this.finishSlot) this.finishSlot.hidden = true; this.bound = false; }
      restoreNative() {
        if (this.nativeWrapper) this.nativeWrapper.hidden = false;
        if (this.wrapper) delete this.wrapper.dataset.tpPhysicalReady;
        this.hidden = true;
        if (this.finishSlot) this.finishSlot.hidden = true;
        this.observer?.disconnect();
        this.productInfo?.removeEventListener('change', this.changeHandler);
        this.bound = false;
      }
      buildUi() {
        this.groups = {};
        const make = (field, title, values, labels) => {
          if (field === 'frame') { this.buildFrameUi(); return; }
          if (field === 'finish') { this.buildFinishUi(); return; }
          const group = win.document.createElement('fieldset');
          group.className = 'product-form__input product-form__input--pill tp-physical-options__group';
          group.dataset.tpGroup = field;
          const legend = win.document.createElement('legend'); legend.className = 'form__label'; legend.textContent = title; group.append(legend);
          const choices = win.document.createElement('div'); choices.className = 'tp-physical-options__choices'; group.append(choices);
          values.forEach((value) => {
            const id = ['TpPhysical', this.dataset.section, field, value].join('-');
            const input = win.document.createElement('input');
            input.type = 'radio'; input.name = ['tp-physical', this.dataset.section, field].join('-'); input.id = id; input.value = value; input.dataset.tpField = field;
            const label = win.document.createElement('label'); label.htmlFor = id;
            const text = win.document.createElement('span'); text.textContent = labels[value] || value; label.append(text);
            choices.append(input, label, win.document.createTextNode('\n'));
          });
          this.groups[field] = group; this.ui.append(group);
        };
        make('size', this.model.kind === 'copri' ? this.strings.nominal_size : this.strings.size, this.model.sizes, {});
        make('style', this.strings.style, this.model.styles, this.strings);
        make('frame', this.strings.frame, this.model.frames, this.strings);
        make('finish', this.strings.finish, ['full', 'poster'], this.strings);
        this.controls = Object.values(this.groups).flatMap((group) => Array.from(group.querySelectorAll('input[data-tp-field]')));
        this.finishSlot = this.productInfo.querySelector('[data-tp-physical-finish-slot]');
        if (this.finishSlot) this.finishSlot.append(this.groups.finish);
        if (this.model.kind === 'copri') { const note = win.document.createElement('p'); note.className = 'tp-physical-options__copri-note'; note.textContent = this.strings.copri_note; this.ui.append(note); }
        this.status = win.document.createElement('span'); this.status.className = 'visually-hidden'; this.status.setAttribute('role', 'status'); this.status.setAttribute('aria-live', 'polite'); this.ui.append(this.status);
      }
      makeDetailLink(url, label, accessibleLabel) {
        if (!url) return null;
        const link = win.document.createElement('a'); link.className = 'tp-physical-detail-link'; link.href = url; link.target = '_blank'; link.rel = 'noopener'; link.setAttribute('aria-label', accessibleLabel);
        const text = win.document.createElement('span'); text.textContent = label;
        const arrow = win.document.createElement('span'); arrow.className = 'tp-physical-detail-link__arrow'; arrow.textContent = '→'; arrow.setAttribute('aria-hidden', 'true'); link.append(text, arrow);
        return link;
      }
      buildFrameUi() {
        const root = win.document.createElement('div'); root.className = 'tp-physical-frame'; root.dataset.tpGroup = 'frame';
        const fieldset = win.document.createElement('fieldset'); fieldset.className = 'tp-physical-frame__fieldset';
        const legend = win.document.createElement('legend'); legend.className = 'form__label tp-physical-frame__legend'; legend.textContent = this.strings.frame; fieldset.append(legend);
        const choices = win.document.createElement('div'); choices.className = 'tp-physical-frame__options';
        this.model.frames.forEach((value) => {
          const id = ['TpPhysical', this.dataset.section, 'frame', value].join('-');
          const input = win.document.createElement('input'); input.className = 'tp-physical-frame__input'; input.type = 'radio'; input.id = id; input.name = ['tp-physical', this.dataset.section, 'frame'].join('-'); input.value = value; input.dataset.tpField = 'frame';
          const label = win.document.createElement('label'); label.className = 'tp-physical-frame__label'; label.htmlFor = id;
          const swatch = win.document.createElement('span'); swatch.className = 'tp-physical-frame__swatch tp-physical-frame__swatch--' + value; swatch.setAttribute('aria-hidden', 'true');
          const text = win.document.createElement('span'); text.textContent = this.strings[value]; label.append(swatch, text); choices.append(input, label);
        });
        fieldset.append(choices);
        const help = this.makeDetailLink(this.dataset.frameDetailsUrl, this.strings.frame_details, this.strings.frame_details_a11y); if (help) fieldset.append(help);
        root.append(fieldset); this.groups.frame = root; this.ui.append(root);
      }
      buildFinishUi() {
        const root = win.document.createElement('div'); root.className = 'tp-physical-finish'; root.dataset.tpGroup = 'finish';
        const heading = win.document.createElement('div'); heading.className = 'tp-physical-finish__heading';
        const eyebrow = win.document.createElement('span'); eyebrow.className = 'tp-physical-finish__eyebrow'; eyebrow.textContent = this.strings.finish;
        const intro = win.document.createElement('p'); intro.textContent = this.strings.finish_intro; heading.append(eyebrow, intro); root.append(heading);
        const choices = win.document.createElement('div'); choices.className = 'tp-physical-finish__choices'; choices.setAttribute('role', 'radiogroup'); choices.setAttribute('aria-label', this.strings.finish);
        ['full', 'poster'].forEach((value) => {
          const id = ['TpPhysical', this.dataset.section, 'finish', value].join('-');
          const label = win.document.createElement('label'); label.className = 'tp-physical-finish__choice'; label.htmlFor = id;
          const input = win.document.createElement('input'); input.type = 'radio'; input.id = id; input.name = ['tp-physical', this.dataset.section, 'finish'].join('-'); input.value = value; input.dataset.tpField = 'finish';
          const preview = win.document.createElement('span'); preview.className = 'tp-physical-finish__preview tp-physical-finish__preview--' + value; preview.setAttribute('aria-hidden', 'true'); preview.append(win.document.createElement('i'));
          const title = win.document.createElement('strong'); title.textContent = this.strings[value];
          const detail = win.document.createElement('small'); detail.textContent = this.strings[value + '_tip']; label.append(input, preview, title, detail); choices.append(label);
        });
        root.append(choices);
        this.note = win.document.createElement('p'); this.note.className = 'tp-physical-border-note'; this.note.textContent = this.strings.print_note; root.append(this.note);
        this.formatNote = win.document.createElement('p'); this.formatNote.className = 'tp-physical-finish__note'; this.formatNote.textContent = this.model.kind === 'copri' ? this.strings.copri_format_note : this.strings.format_note; root.append(this.formatNote);
        this.technicalLink = this.makeDetailLink(this.dataset.detailsUrl, this.strings.details, this.strings.details_a11y); if (this.technicalLink) root.append(this.technicalLink);
        this.groups.finish = root; this.ui.append(root);
      }
      readNative() {
        const native = this.nativeWrapper.querySelector('variant-selects');
        const json = native?.querySelector('[data-selected-variant]');
        if (!json) return false;
        const selected = JSON.parse(json.textContent);
        const mapped = this.model.variants.find((variant) => variant.id === String(selected?.id));
        if (!mapped) return false;
        mapped.available = selected.available !== false;
        this.nativeElement = native;
        this.state = stateFrom(mapped);
        this.pendingId = null;
        this.removeAttribute('aria-busy');
        this.renderState();
        return true;
      }
      renderState() {
        if (!this.state) return;
        const framed = this.state.style === 'framed', finishing = this.state.style !== 'canvas';
        this.groups.frame.hidden = !framed;
        this.groups.finish.hidden = !finishing;
        if (this.finishSlot) this.finishSlot.hidden = !finishing;
        this.controls.forEach((input) => {
          const field = input.dataset.tpField;
          const desired = nextState(this.model, this.state, field, input.value);
          const candidate = resolve(this.model, desired);
          const active = (field !== 'frame' || framed) && (field !== 'finish' || finishing);
          input.checked = this.state[field] === input.value;
          input.disabled = !active || !candidate || !candidate.available;
        });
        this.note.hidden = this.state.style !== 'print';
        if (this.technicalLink) this.technicalLink.hidden = !framed;
        const selected = resolve(this.model, this.state);
        this.status.textContent = selected && !selected.available ? this.strings.unavailable : '';
      }
      selectNative(variant) {
        try {
          const native = this.nativeWrapper.querySelector('variant-selects');
          const current = JSON.parse(native.querySelector('[data-selected-variant]').textContent);
          if (String(current?.id) === variant.id && !this.pendingId) return;
          const groups = Array.from(native.querySelectorAll('fieldset, .product-form__input--dropdown'));
          if (groups.length !== 3) throw new Error('Native option groups changed');
          const targets = groups.map((group, index) => {
            const select = group.querySelector('select');
            if (select) {
              const selected = Array.from(select.options).find((option) => option.value === variant.rawOptions[index]);
              if (!selected?.dataset.optionValueId) throw new Error('Native option value missing');
              Array.from(select.options).forEach((option) => { option.selected = option === selected; if (option === selected) option.setAttribute('selected', 'selected'); else option.removeAttribute('selected'); });
              return select;
            }
            const inputs = Array.from(group.querySelectorAll('input[data-option-value-id]'));
            const selected = inputs.find((input) => input.value === variant.rawOptions[index]);
            if (!selected?.dataset.optionValueId) throw new Error('Native option value missing');
            inputs.forEach((input) => { input.checked = input === selected; });
            return selected;
          });
          this.pendingId = variant.id;
          this.setAttribute('aria-busy', 'true');
          targets[2].dispatchEvent(new win.Event('change', { bubbles: true }));
        } catch (_) { this.restoreNative(); }
      }
    };
  }
  return { mapVariant, createModel, resolve, nextState, stateFrom, elementClass };
});
